import { inject } from '@angular/core';
import { CanMatchFn, Routes } from '@angular/router';
import {
  checkoutSuccessGuard,
  mercadopagoRedirectGuard,
} from '@seatix/checkout-data-access';
import { checkoutExitPreventionGuard } from './checkout-exit-prevention.guard';
import { CheckoutFeatLayoutComponent } from '@seatix/checkout-feat-layout';
import { injectFanPortalUrl } from '@seatix/shared/core';
import { ROUTES } from '@seatix/shared-util-routing';
import { DOCUMENT } from '@angular/common';

const rootRedirectGuard: CanMatchFn = () => {
  inject(DOCUMENT).location.href = injectFanPortalUrl();
  return false;
};

export const routes = [
  {
    path: '',
    component: CheckoutFeatLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        canMatch: [rootRedirectGuard],
        children: [],
      },
      {
        path: ROUTES.CHECKOUT.ORDER,
        loadComponent: () => import('@seatix/checkout-feat-shell'),
        canMatch: [mercadopagoRedirectGuard],
        canDeactivate: [checkoutExitPreventionGuard],
      },
      {
        path: ROUTES.CHECKOUT.SUCCESS,
        loadComponent: () =>
          import('@seatix/checkout/feat-success').then(
            (m) => m.CheckoutSuccessPage,
          ),
        canMatch: [checkoutSuccessGuard],
      },
    ],
  },
] as Routes;
